import { render, staticRenderFns } from "./EditAlbum.vue?vue&type=template&id=b6a5b6fe&scoped=true&"
import script from "./EditAlbum.vue?vue&type=script&lang=js&"
export * from "./EditAlbum.vue?vue&type=script&lang=js&"
import style0 from "./EditAlbum.vue?vue&type=style&index=0&id=b6a5b6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a5b6fe",
  null
  
)

export default component.exports